import React, { Component, Fragment } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import { SidePanel } from '../../common/SidePanel';
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import { isNumber } from '../../utils/Validation';

export class ProductSizeVariantThingGenerator extends Component {
    static displayName = ProductSizeVariantThingGenerator.name;

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            error: null,
            loading: true,
            index: props.data?.index,
            id: props.data?.id,
            sizeCode: props.data?.sizeCode || '',
            sizeDisplayTitle: props.data?.sizeDisplayTitle || '',
            quantityInStock: isNumber(props.data?.quantityInStock) ? props.data.quantityInStock : '0',
            thingsToAdd: '',
            thingList: [],
            generateLoading: false,
        };
        console.log(props.data)

        this.populateData = this.populateData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    handleInputChange(event) {
        const target = event.target;

        let value;
        switch (target.type) {
            case 'checkbox':
                value = target.checked;
                break;
            case 'file':
                value = target.files[0];
                break;
            default:
                value = target.value;
                break;
        }
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    async populateData(done) {
        if(!isNumber(this.state.id)) {
            this.setState({
                loading: false
            });
            return;
        }
        const token = await authService.getAccessToken();
        const response = await fetch(`/api/brand/${this.state.designerId}/thing/variant/${this.state.id}/list-all-things`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        console.log(data);
        this.setState({
            thingList: data,
            loading: false
        });
        if (done) done();
    }

    async handleSubmit(event) {
        event.preventDefault();

        this.setState({ generateLoading: true });

        console.log('generating..');

        const token = await authService.getAccessToken();
        if (!token) {
            this.setError(`Could not retrieve authentication`);
            return;
        }

        const total = parseInt(this.state.thingsToAdd);

        const response = await fetch(`/api/brand/${this.state.designerId}/thing/variant/${this.state.id}/generate-things`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                total: total
            })
        });

        try {
            const newDta = await response.json();
            console.log(newDta);

            if (newDta && newDta.result) {
                const { index, id, sizeCode, sizeDisplayTitle } = this.state;

                const newQuantity = this.state.thingList.length + newDta.addedThings.length;

                this.setState({
                    thingList: [
                        ...this.state.thingList,
                        ...newDta.addedThings
                      ],
                    generateLoading: false,
                    thingsToAdd: '',
                    quantityInStock: newQuantity
                });

                this.props.update({
                    index,
                    id,
                    sizeCode,
                    sizeDisplayTitle,
                    quantityInStock: newQuantity,
                    totalThingsAdded: newDta.addedThings.length
                });
                return;
            }
        } catch {

        }

        this.setState({
            generateLoading: false,
            thingsToAdd: ''        
        });
    }

    render() {
        if(!isNumber(this.state.id)) {
            return (
                <SidePanel onExited={this.props.onExited}>
                    <div>
                        <h1>IDs Generator</h1>
                        <p>You can't generate unique IDs for for this varient yet. You need to publish the product first.</p>
                        <div className='pt-5'>
                            <Button color="dark" size="sm" className="mb-3" onClick={() => this.props.onExited()}>Close</Button>
                        </div>
                    </div>
                </SidePanel>
            );
        }

        if(this.state.loading) {
            return (
                <SidePanel onExited={this.props.onExited}>
                    <div>
                        <h1>IDs Generator</h1>
                        <p>Loading...</p>
                    </div>
                </SidePanel>
            );
        }


        const { thingList } = this.state;

        let items = thingList.map((item, index) => {
            return (
                <tr key={index}>
                    <th scope="row">{index+1}</th>
                    <td><a href={item.url} target='_blank'>{item.url}</a></td>
                </tr>
            );
        });

        return (
            <SidePanel onExited={this.props.onExited}>
                <div>
                    <h1>IDs Generator</h1>
                    <p>Generator a number of IDs to your product.</p>
                    <Form onSubmit={this.handleSubmit}>
                        <FormGroup>
                            <Label for="ThingsToAdd">Total new IDs to generate</Label>
                            <Input type="number" name="thingsToAdd" id="ThingsToAdd"
                                value={this.state.thingsToAdd}
                                maxLength="3"
                                max="100"
                                min="1"
                                onChange={this.handleInputChange}
                                style={{ maxWidth: '140px' }}
                                className="simpletxt"
                            />
                        </FormGroup>

                        <Button className="mt-1" color="dark" size="sm">Generate</Button>
                    </Form>
                    <hr className='my-3'/>
                    <p>List of unique IDs</p>
                    <div className="table-responsive">
                        <table className="table table-hover table-sm table-borderless table-striped">
                            <caption>List of unique IDs</caption>
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">Num</th>
                                    <th scope="col">Url</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items}
                            </tbody>
                        </table>
                    </div>


                </div>
            </SidePanel>
        );
    }
}
